import { render, staticRenderFns } from "./InfoLink.vue?vue&type=template&id=0e85a7a6&"
import script from "./InfoLink.vue?vue&type=script&lang=js&"
export * from "./InfoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports